import { PayStatus } from "@/models/etc/types";
import { i18n } from "@/i18n";

// dd.MM.yy (UTC); пустая строка, если значение отсутствует/некорректно
export const formatShortDate = (value: Date | string | undefined | null): string => {
	if (!value) {
		return ''
	}
	const d = new Date(value)
	if (Number.isNaN(d.getTime())) {
		return ''
	}
	const day = String(d.getUTCDate()).padStart(2, '0')
	const month = String(d.getUTCMonth() + 1).padStart(2, '0')
	const year = String(d.getUTCFullYear()).slice(-2)
	return `${day}.${month}.${year}`
}

export const payStatusText = (status: PayStatus | number | undefined): string => {
	switch (status) {
		case PayStatus.Cancelled: return String(i18n.global.t('cancelled'))
		case PayStatus.NotPayed: return String(i18n.global.t('not_paid'))
		case PayStatus.PartlyPayed: return String(i18n.global.t('partially_paid'))
		case PayStatus.Payed: return String(i18n.global.t('paid'))
		default: return String(i18n.global.t('unknown_label'))
	}
}

// ширина заливки прогресс-бара, 0..100 %
export const barWidth = (percent: number | undefined | null): string => {
	const p = Math.max(0, Math.min(100, percent ?? 0))
	return `${p}%`
}

// Реэкспорт общего форматтера: суммы должны следовать локали пользователя
export { formatMoney } from '@/utils/format'
